import { render } from "./Documents.vue?vue&type=template&id=130f792a&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=130f792a&scoped=true&lang=css"

import exportComponent from "/Users/ruwan/projects/eopp/eopp-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130f792a"]])

export default __exports__